
// src/web/components/notifications-item.jsx

import React from 'react'
import connect from '../../connects/notifications-item'
import { InviewSensor } from './infinite-scroller';
import moment from 'moment'
import { translate } from 'react-i18next'
import { convertEmojiHTML } from '../../helpers/emoji-helpers'
import {
  IconButton,
} from 'react-toolbox/lib/button'
import {
  ListItem,
} from 'react-toolbox/lib/list'
import wrapedListTheme from './themes/announces-list.css'
import DiaryTimestamp from './diary-timestamp.jsx'

class NotificationsItem extends React.Component {
  constructor(props) {
    super(props)
    this.state = { prioritized:  !!props.notification.priority }
  }

  render() {
    const {
      notification,
      onClick,
      togglePriority,
    } = this.props
    const {
      priority,
      category,
      delivered_at,
      created_at,
    } = notification
    const description = convertEmojiHTML(notification.description)

    return (
      <ListItem selectable
          className={!delivered_at && 'unread' || ''}
          onClick={onClick}
          caption={<span dangerouslySetInnerHTML={{__html: description}} />}
          legend={<DiaryTimestamp timestamp={created_at}/>}
          avatar={notification.icon_image.thumb_url}
          rightActions={[this.state.prioritized && <IconButton key="button" icon={priority ? "star" : "star_border"} style={{ color: priority ? '#FFCC00' : '#000' }} onClick={togglePriority}/>]}
          theme={wrapedListTheme} />
    )
  }
}

export const RawNotificationsItem = NotificationsItem
export default connect(NotificationsItem)



// WEBPACK FOOTER //
// ./src/web/components/notifications-item.jsx